// extracted by mini-css-extract-plugin
module.exports = {"form":"Home_form__myjbl","logo":"Home_logo__16qAu","message":"Home_message__1KOId"};